const modulesVisibilityCache = {};
let helpText = null;

const { ADV, clone } = window;

export const getHelpText = () => {
  if (helpText === null) {
    helpText = ADV.util.getCurrentClient(ADV.data).HelpText;
  }

  return helpText;
};

export const getModulesToHide = () => {
  const currentClient = ADV.util.getCurrentClient(ADV.data);
  return clone(currentClient.ModulesToHide) || [];
};

export const isModuleVisible = (viewModule, modulesToHide) => {
  if (!modulesVisibilityCache.hasOwnProperty(viewModule)) {
    modulesVisibilityCache[viewModule] = !modulesToHide.find(
      moduleToHide => moduleToHide === viewModule,
    );
  }
  return modulesVisibilityCache[viewModule];
};

export const solveNavigation = (
  modulesToHide,
  consumerAccessWorkflow,
  clientId,
  isConsumerArea,
) => {
  const NO_WORKFLOW = -1;
  const DEFAULT_WORKFLOW = 0;
  const MANAGED_ACCOUNTS_WORKFLOW = 1;

  let navigation = [];

  const modulesToHideMap = {};
  modulesToHide.forEach(moduleToHide => {
    modulesToHideMap[moduleToHide] = true;
  });

  switch (consumerAccessWorkflow) {
    case NO_WORKFLOW: {
      navigation = [
        {
          label: 'Overview',
          icon: 'fa fa-flag',
          page: 'ConsumerOverview',
          route: `overview/${clientId}`,
          sub_pages: null,
        },
        {
          label: 'Profile',
          icon: 'fa fa-user',
          page: null,
          route: null,
          sub_pages: [
            {
              label: 'Personal Info',
              route: `profile/personalinfo/${clientId}/0`,
              page: 'Profile',
            },
            {
              label: 'Goals',
              route: `profile/goals/${clientId}/0`,
              page: 'Profile',
            },
            {
              label: 'Accounts',
              route: `profile/accounts/${clientId}`,
              page: 'ProfileAccounts',
              id: 'Profile.Accounts',
            },
            {
              label: 'Other Assets',
              route: `profile/otherassets/${clientId}/0`,
              page: 'Profile',
            },
            {
              label: 'Equity Compensation',
              route: `profile/stockoptions/${clientId}/0`,
              page: 'ProfileStockOptions',
            },
            {
              label: 'Insurance',
              route: `profile/insurance/${clientId}/0`,
              page: 'ProfileInsurance',
            },
            {
              label: 'Income',
              route: `profile/income/${clientId}/0`,
              page: 'ProfileIncome',
            },
            {
              label: 'Taxes',
              route: `profile/taxfiling/${clientId}/0`,
              page: 'Profile',
            },
            {
              label: 'Expenses',
              route: `profile/expenses/${clientId}/0`,
              page: 'ProfileExpenses',
            },
            {
              label: 'Risk Tolerance',
              route: `profile/risktolerance/${clientId}/0`,
              page: 'ProfileRiskTolerance',
            },
          ],
        },
        {
          label: 'Current Finances',
          id: 'CurrentFinances',
          icon: 'far fa-chart-bar',
          page: null,
          route: null,
          sub_pages: [
            {
              label: 'Net Worth',
              route: `networth/${clientId}/0`,
              page: 'NetWorth',
            },
            {
              label: 'Transactions',
              route: `transactions/${clientId}/0`,
              page: 'Transactions',
            },
          ],
        },
        {
          label: 'Financial Plan',
          id: 'FinancialPlan',
          icon: 'fa fa-location-arrow',
          page: null,
          route: null,
          sub_pages: [
            {
              label: 'Goal Results',
              route: `planWhatIfs/${clientId}/summary/false/`,
              page: 'NewFinancialPlanWhatIfs',
            },
            {
              label: 'Cash Flow',
              route: `projectedcashflowreport/${clientId}/1`,
              page: 'ProjectedCashFlowReport',
            },
            {
              label: 'Balance Sheet',
              route: `balance_sheet/${clientId}/0`,
              page: 'ProjectedBalanceSheet',
            },
            {
              label: 'Reports',
              route: `reports/${clientId}/`,
              page: 'AdvancedReports',
            },
            {
              label: 'React Asset Allocation',
              route: `reports/AssetAllocation/${clientId}`,
              page: 'ReactAssetAllocationReport',
            },
            {
              label: 'Action Steps',
              route: `tasksV2/${clientId}`,
              page: 'TasksV2',
            },
          ],
        },
        {
          label: 'Document Vault',
          icon: 'fa fa-cube',
          page: 'DocumentVault',
          route: `document_vault/${clientId}/`,
          sub_pages: null,
        },
      ];

      break;
    }
    case DEFAULT_WORKFLOW:
      break;
    case MANAGED_ACCOUNTS_WORKFLOW: {
      navigation.push({
        label: 'Managed Accounts',
        icon: 'fa fa-university',
        page: 'ManagedAccounts',
        action: 'ShowManagedAccountsTable',
        sub_pages: null,
      });
      break;
    }
    default:
      break;
  }

  if (isConsumerArea) {
    navigation = navigation.filter(menu => !modulesToHideMap.hasOwnProperty(menu.id || menu.label));

    navigation.forEach(menu => {
      if (menu.sub_pages) {
        menu.sub_pages = menu.sub_pages.filter(
          submenu => !modulesToHideMap.hasOwnProperty(submenu.id || submenu.label),
        );
      }
    });
  }

  return navigation;
};

export const selectPage = (navigation, currentPage) => {
  const localNavigation = clone(navigation);
  localNavigation.some(nav => {
    if (nav.name === currentPage) {
      nav.page_selected = true;
      return true;
    } else if (nav.sub_pages) {
      const found = nav.sub_pages.some(sub => {
        if (sub.name === currentPage) {
          sub.page_selected = true;
          return true;
        }
        return false;
      });
      if (found) {
        nav.page_selected = true;
        return true;
      }
    }
    return false;
  });
  return localNavigation;
};
